import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import manageIcon from "../../../assets/images/logoForPlaid.png";
import { Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { MODULE_API } from "../../../apis";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import "../LiabilityDashboard.css";
import moment from "moment";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";


export const FutureLoan = (props) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const tableLoader = {
    spinning: props.loading || loading,
    indicator: <LoadingOutlined style={{ fontSize: 20, color: "#2a3da3" }} spin />,
  };
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const Loancols = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Financial Institution",
      dataIndex: "Name of Financial Institution",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    {
      title: "Interest Rate(%APR)",
      dataIndex: "Interest Rate",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Maturity Date",
      dataIndex: "Maturity Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Loan Balance",
      dataIndex: "Loan Balance",
      render: (record,row) =>{
        const value = row && row["Loan Balance"] || row["Initial Loan Amount"];
        return value
          ? !isNaN(value)
            ? `${"$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A";
      }
      // render: (record) =>
      //   record
      //     ? !isNaN(record)
      //       ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      //       : "N/A"
      //     : "N/A",
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id, record.managedBy, record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
            {record.managedBy === "Plaid" && (
            <div className="managed-by-plaid-icon"> </div>
            )}
          </div>
        );
      },
    },
  ];
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deletePost = async (id, managedBy, recordToDelete) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        try {
          setLoading(true);
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setLoading(false);
          props.updateSharedState(!props.sharedState);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };

  const fnEdit = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}/view`
    );
  };
  console.log("future loansss", props.futureLoans && props.futureLoans);
  return (
    <div className="liablityInfoMaincard" style={{ position: "relative" }}>
      <h3 className="liablitycardheading">
      <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
        Future Loan
        <ToolTipCreator name={"Liabilities_Future_Loan"}/>
      </div>
      </h3>
      <Table
        columns={Loancols}
        dataSource={props.futureLoans && props.futureLoans}
        loading={tableLoader}
        pagination={{
          showSizeChanger: false, // Show the page size changer
          pageSizeOptions: ["10", "20", "50", "100"], // Options for page size
          defaultPageSize: 10, // Default page size
        }}
        // pagination={{
        //   total: props.totalPages * 10, // Assuming 10 items per page
        //   current: props.currentPage,
        //   onChange: (page) => {
        //     props.setCurrentPage(page);
        //   },
        //   pageSize: 10, // Number of items per page
        // }}
      />
    </div>
  );
};
